module.exports = __webpack_public_path__ + "static/media/slide3.e4130257.jpg";